export default "__VITE_ASSET__DuQrqlFl__"